module.exports = __webpack_public_path__ + "static/media/star_more_half.df15fdd3.png";